import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import * as Icon from 'react-bootstrap-icons';
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";

export default function InlineDnDList({ items, showModal }) {
    const [itemData, setItemData] = useState(items || []);
    const updateImagePosition = (body) => {
        Api.PostApi(endPoints.IMAGESWAP, body).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                Api.Alert(res.data.data, "success")
            }
        })
    }
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedItems = [...itemData];
        const [removed] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, removed);
        console.log("reorderedItems item", itemData)
        console.log("reorderedItems", reorderedItems)
        let body = {
            "location": reorderedItems[0].location_id,
            "image_ids": reorderedItems.map((data) => data._id)
        }
        console.log("reorderedItems body", body)
        updateImagePosition(body)
        setItemData(reorderedItems);
    };

    useEffect(() => {
        setItemData(items)
    }, [items])

    return (
        <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="droppable-inline" direction="horizontal">
                {(provided) => (
                    <div
                        className="inline-container logoUpdateBox__img logoUpdateBox__grid"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {itemData.map((item, index) => (
                            <Draggable key={item._id} draggableId={item._id} index={index} >
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                            cursor: "grab",
                                            ...provided.draggableProps.style,
                                        }} className='logoUpdateBox__Box'>
                                        <button className="deleteBtn btn btn-danger btn-sm" title="Remove image" onClick={() => showModal("", item?._id, "deleteStationimg")}>
                                            <Icon.Trash />
                                        </button>
                                        <img src={item.url} alt="" />
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}
